import { Injectable, InjectionToken } from "@angular/core";
import { OrderGetQueryResult, OrderListGetQueryResult, PreOrderListGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IOrderApiService {
  abstract orderListGetAsync(loadReferences: boolean, orderDateMinimum: Date | undefined): Promise<OrderListGetQueryResult>;

  abstract orderGetByNrAsync(webshopOrderNumber: string | undefined, integraOrderNumber: string | undefined): Promise<OrderGetQueryResult>;

  abstract orderGetByDidAsync(integraBelegDid: string | undefined): Promise<OrderGetQueryResult>;

  abstract preOrderListGetAsync(): Promise<PreOrderListGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IOrderApiServiceToken = new InjectionToken<IOrderApiService>('IOrderApiServiceToken');
